import React, { Component } from 'react';
import commonUtil from '../../../../../../utils/commonUtil';
export default class PaginationIndicator extends Component {
  render() {
    const {
      currentPage = 0,
      totalPages = 0,
      onPreviousClick,
      onNextClick,
      onPageClick = () => {},
    } = this.props;

    const pages = Array.from({ length: Number(totalPages) }, (_, i) => i + 1);
    const hasNextPage = Number(currentPage) < Number(totalPages);
    const hasPreviousPage = Number(currentPage) > 1;
    const hasLastPage = Number(totalPages) > 5; //show the last page icon if total pages are more than 5
    
    if (pages.length <= 1) return null;

    return (
      <div className="row paginationIndicator">
        <div
          className="col-xs-12"
          style={{
            display: 'flex',
            alignItems: 'center',
            columnGap: '0.25em',
            justifyContent: 'end',
          }}
        >
          {hasPreviousPage && <svg
            onClick={hasPreviousPage ? onPreviousClick : undefined}
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: '1em', cursor: hasPreviousPage ? 'pointer' : undefined }}
          >
            <path
              d="M7.70492 1.41L6.29492 0L0.294922 6L6.29492 12L7.70492 10.59L3.12492 6L7.70492 1.41Z"
              fill={!hasPreviousPage ? '#D8D8D8' : '#333333'}
            />
          </svg>}
          {pages.map((page) => {
            const onCurrentPage = page === Number(currentPage);
            return (
              <div
                onClick={onCurrentPage ? undefined : () => onPageClick(page)}
                style={{
                  fontWeight: onCurrentPage ? '600' : '300',
                  width: '2em',
                  height: '2em',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '25px',
                  color: '#5C5C5C' ,
                  boxShadow: onCurrentPage ? '0px 2px 4px rgba(0, 0, 0, 0.15)' : 'none',
                  cursor: onCurrentPage ? undefined : 'pointer',
                }}
              >
                {page}
              </div>
            );
          })}        
          { hasNextPage && <svg
            onClick={hasNextPage ? onNextClick : undefined}
            width="8"
            height="12"
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: '1em', cursor: hasNextPage ? 'pointer' : undefined }}
          >
            <path
              d="M1.70504 0L0.295044 1.41L4.87504 6L0.295044 10.59L1.70504 12L7.70504 6L1.70504 0Z"
              fill={!hasNextPage ? '#D8D8D8' : '#333333'}
            />
          </svg>}

          {
            <div className='pagination-last-page'
              onClick={() => onPageClick(totalPages)}
              style={{
                width: '24px',
                height: '24px',
                cursor: 'pointer',
                marginLeft: '1em',
              }}>
              <img src={commonUtil.getAssetURL() + '/images/double_arrow_right.svg'} alt="Last Page Icon" />
            </div>
          }
        </div>
      </div>
    );
  }
}
